<ng-container>
    <div class="dialog-main">
        <h2 mat-dialog-title
            class="draggable-dialogue-header"
            cdkDrag
            cdkDragRootElement=".cdk-overlay-pane"
            cdkDragHandle>
            Preset Grid Filter
        </h2>

        <div style="display: grid;" class="column-list">

            <div style="grid-column: 1;">
                <mat-form-field appearance="outline" style="width: auto;">
                    <mat-select [formControl]="filterColumn"
                                placeholder="Column">
                        <mat-option [value]="col.id" *ngFor="let col of Columns" title="{{col}}">
                            {{col.displayName}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div style="grid-column: 2;">
                <mat-form-field appearance="outline" style="width: 150px;">
                    <mat-select [(ngModel)]="filterOperator" placeholder="Operator">
                        <mat-option value="eq">
                            equals
                        </mat-option>
                        <mat-option value="neq">
                            not equal to
                        </mat-option>
                        <mat-option value="contains">
                            contains
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div style="grid-column: 3;">
                <mat-form-field>
                    <mat-label>Field value</mat-label>
                    <input matInput type="text" id="filterFieldValue" [(ngModel)]="filterFieldValue">
                </mat-form-field>
            </div>

            <div style="grid-column: 4;">
                <button mat-mini-fab
                        aria-label="Add Filter"
                        title="Add Filter"
                        color="primary"
                        class="add-filter-button"
                        [disabled]="!filterOperator || !filterFieldValue"
                        (click)="addFilterButtonClick()">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>

        <div>
            <ul>
                <li *ngFor="let fc of FilterClauses">
                    {{fc.columnDisplayName}} {{fc.filterOperatorDescription}} {{fc.filterMatchValue}}
                </li>
            </ul>
        </div>

        <br />

        <mat-form-field class="filter-name">
            <mat-label>Preset Filter Name</mat-label>
            <input matInput maxlength="50" [(ngModel)]="filterName">
        </mat-form-field>

        <br />

        <mat-dialog-actions>
            <button mat-raised-button
                    class="theme-primary-btn"
                    color="primary"
                    (click)="saveButtonClicked()">
                Save
            </button>
            &nbsp;
            <button mat-raised-button mat-dialog-close>
                Cancel
            </button>
            <button mat-raised-button mat-dialog-close
                    color="warn"
                    (click)="deleteButtonClicked()">
                Delete Existing Filter
            </button>
        </mat-dialog-actions>
    </div>
</ng-container>
